const E164_MIN_DIGITS = 8;
const E164_MAX_DIGITS = 15;
const MEXICO_COUNTRY_CODE = '52';
const MEXICO_LOCAL_DIGITS = 10;

/**
 * Convierte teléfonos a E.164 sin alterar números internacionales existentes.
 * Los números locales de 10 dígitos se consideran mexicanos.
 */
export function normalizePhoneNumber(value?: string | null): string {
  const original = value?.trim() ?? '';
  if (!original) return '';

  const hasInternationalPrefix = original.startsWith('+') || original.startsWith('00');
  const digits = original.replace(/\D/g, '');
  if (!digits) return original;

  if (!hasInternationalPrefix && digits.length === MEXICO_LOCAL_DIGITS) {
    return `+${MEXICO_COUNTRY_CODE}${digits}`;
  }

  const internationalDigits = original.startsWith('00')
    ? digits.slice(2)
    : digits;

  if (
    internationalDigits.length >= E164_MIN_DIGITS
    && internationalDigits.length <= E164_MAX_DIGITS
  ) {
    return `+${internationalDigits}`;
  }

  // Se conserva el valor para no corromper extensiones o datos incompletos.
  return original;
}

/** Devuelve únicamente los dígitos de un teléfono internacional válido. */
export function internationalPhoneDigits(value?: string | null): string {
  const normalized = normalizePhoneNumber(value);
  if (!normalized.startsWith('+')) return '';

  const digits = normalized.slice(1);
  return digits.length >= E164_MIN_DIGITS && digits.length <= E164_MAX_DIGITS
    ? digits
    : '';
}
